import React from 'react'

export const AccountFields = ({ user, handleChange }) => {
  return (
    <>
      <h3 className="text-18 text-purple-dark mb-8">Personal Information</h3>
      <div className="bg-white border-1 border-gray-200 shadow-100 rounded-10 px-20 sm:px-32 pt-32 mb-64">
        <div className="flex -mx-16">
          <div className="w-full mx-16">
            <label className="block mb-12" htmlFor="firstName">
              First Name *
            </label>
            <input
              className="w-full px-16 bg-gray-100 border-1 border-gray-200 rounded-8 h-56 mb-40"
              id="firstName"
              type="text"
              name="firstName"
              defaultValue={user.profile.firstName}
              onChange={handleChange}
              required
            />
          </div>
          <div className="w-full mx-16">
            <label className="block mb-12" htmlFor="lastName">
              Last Name *
            </label>
            <input
              className="w-full px-16 bg-gray-100 border-1 border-gray-200 rounded-8 h-56 mb-40"
              id="lastName"
              type="text"
              name="lastName"
              defaultValue={user.profile.lastName}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="flex -mx-16">
          <div className="w-full mx-16">
            <label className="block mb-12" htmlFor="email">
              Email Address *
            </label>
            <input
              className="w-full px-16 bg-gray-100 border-1 border-gray-200 rounded-8 h-56 mb-40"
              id="email"
              type="email"
              name="email"
              defaultValue={user.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="w-full mx-16">
            <label className="block mb-12" htmlFor="phone">
              Phone Number *
            </label>
            <input
              className="w-full px-16 bg-gray-100 border-1 border-gray-200 rounded-8 h-56 mb-40"
              id="phone"
              type="text"
              name="phone"
              defaultValue={user.profile.phone}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="flex -mx-16">
          <div className="w-full mx-16">
            <label className="block mb-12" htmlFor="username">
              Username *
            </label>
            <input
              className="w-full px-16 bg-gray-100 border-1 border-gray-200 rounded-8 h-56 mb-40"
              id="username"
              type="text"
              name="username"
              defaultValue={user.username}
              onChange={handleChange}
              required
            />
          </div>
          <div className="w-full mx-16">
            <label className="block mb-12" htmlFor="currentPassword">
              Current Password
            </label>
            <input
              className="w-full px-16 bg-gray-100 border-1 border-gray-200 rounded-8 h-56 mb-40"
              id="currentPassword"
              type="password"
              name="currentPassword"
              defaultValue={user.currentPassword}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="flex -mx-16">
          <div className="w-full mx-16">
            <label className="block mb-12" htmlFor="newPassword">
              New Password
            </label>
            <input
              className="w-full px-16 bg-gray-100 border-1 border-gray-200 rounded-8 h-56 mb-40"
              id="newPassword"
              type="assword"
              name="newPassword"
              defaultValue={user.newPassword}
              onChange={handleChange}
            />
          </div>
          <div className="w-full mx-16" />
        </div>
      </div>
    </>
  )
}
